// InsertDialog.tsx
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
type InsertDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  placeholder: string;
  onSubmit: (value: string) => void;
};
const InsertDialog: React.FC<InsertDialogProps> = ({
  open,
  onOpenChange,
  title,
  placeholder,
  onSubmit
}) => {
  const [value, setValue] = useState("");
  return <Dialog open={open} onOpenChange={onOpenChange} data-sentry-element="Dialog" data-sentry-component="InsertDialog" data-sentry-source-file="index.tsx">
            <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="index.tsx">
                <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="index.tsx">
                    <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="index.tsx">{title}</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <Input placeholder={placeholder} value={value} onChange={e => setValue(e.target.value)} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
                    <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="index.tsx">
                        <Button variant="secondary" onClick={() => onOpenChange(false)} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                            Cancel
                        </Button>
                        <Button onClick={() => {
            if (value) {
              onSubmit(value);
              onOpenChange(false);
              setValue("");
            }
          }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                            Insert
                        </Button>
                    </DialogFooter>
                </div>
            </DialogContent>
        </Dialog>;
};
export default InsertDialog;